export default __webpack_public_path__ + "static/media/pressure.0c962b0b.png";